export default {
  PRODUCT_LIST: {
    1: 'MAXHUB 会议平板',
    2: '5方 MAXHUB 云会议',
    3: 'MAXHUB Teams'
  }
}